import { useEffect } from 'react';

export default function SEO({ title, description, keywords, image }) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    const setProp = (prop, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[property="${prop}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', prop);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    setMeta('description', description);
    setMeta('keywords', keywords);
    setProp('og:title', title);
    setProp('og:description', description);
    if (image) setProp('og:image', image);
  }, [title, description, keywords, image]);
  return null;
}
